module.exports = __webpack_public_path__ + "static/media/protection.a8ac83df.svg";